module.exports = __webpack_public_path__ + "45392a29cf855195b4c55944ff9550ef.MP3";